$(document).ready(function() {

  if (location.pathname === '/cart') {

    $('.cart__dynamic-checkout-buttons').hide(); 

    var today = new Date();
    var minDate = 0;

    $("#tybo-shipping-date").datepicker({
      minDate: 2,     
      maxDate: 7,  
      stepMonths: 1,
      onSelect: function(date) {} 
    });
  
    $('.shipping-method-tybo').on('change', function() {
      $('.tybo-date-input').val('');
      
      if ($(this).val().length) {
        $('.tybo-date-input').prop('disabled', false);
        $('.tybo-date-input').prop('readonly', true);
      } else {
        $('.tybo-date-input').prop('disabled', true);
        $('.tybo-date-input').prop('readonly', false);
      }
  
      if ($(this).val() == 'Shipping') {             
        $('.shipping-terms').show();
      } else {
        $('.shipping-terms').hide();
      }
    });
  
    $('.custom-tybo-checkout').click(function() {
      $('.tybo-qty-validation').hide(); 
      $('.tybo-shipping-validation').hide();
      $('.tybo-pickup-time-validation').hide();
      var shippingMethod = $('.shipping-method-tybo').val();
      var shippingDate = $('.tybo-date-input').val() ? $('.tybo-date-input').val() : false; 
      var pickupTime = $('.pickup-time-tybo').val(); 

      $.getJSON('/cart.js', function(cart) {
        if (!shippingMethod.length || !shippingDate.length) { 
          $('.tybo-shipping-validation').show();
        } else if ($('.shipping-method-tybo').val() == 'Shipping' && !$("#agree-shipping").is(":checked")) {
          $('.tybo-shipping-terms').show(); 
        } else {  
          var attributes = {};
    
          attributes['Shipping Method'] = shippingMethod;
    
          if (shippingMethod == 'Pickup') {
            attributes['Pickup Date'] = shippingDate;
            attributes['Pickup Time'] = pickupTime;
            attributes['Shipping Date'] = null;
          } else {
            attributes['Shipping Date'] = shippingDate;
            attributes['Pickup Date'] = null;
            attributes['Pickup Time'] = null;
          } 
          
          $.ajax({ 
            type: 'POST',
            url: '/cart/update.js',
            data: {
              'attributes': attributes 
            },
            dataType: 'json',
            success: function() {  
              $('.cart__checkout-button').click();
            } 
          });       
        }
      }); 
    });
  }
});